/**
 * AddNoteCtrl controller
 * Add/Edit Subscriber's note
 */
import { NOTE_SUB_TYPES, NOTE_TYPES } from '../../app/core/constants'

/**
 * AddNoteCtrl controller
 *
 * @class AddNoteCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AddNoteCtrl
 */
/* @ngInject */
export default function AddNoteCtrl ($uibModalInstance, authSvc, viewMode, subscr, note) {
  var vm = this

  vm.viewMode = viewMode

  vm.noteSubTypes = NOTE_SUB_TYPES

  vm.noteTypes = angular.copy(NOTE_TYPES)

  /**
   * Note
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   * @type {models.Note}
   */
  vm.note = note

  vm.note.subscriber = subscr

  /**
   * isNew flag
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   * @type {Boolean}
   */
  vm.isNew = note._isNew()

  /**
   * Quill editor toolbar configuration
   * {@link http://quilljs.com/docs/modules/toolbar/}
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   * @type {Object}
   */
  vm.ngQuillToolbar = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'image'],
      ['clean'] // remove formatting button
    ]
  }

  /**
   * Create or edit note, and close modal window afterwards
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    note._trust()
      ._save()
      .then(
        () => {
          $uibModalInstance.close(note)
        }
      )
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
